import React from 'react';
import { Tag } from 'lucide-react';

type PostType = 'Chia sẻ' | 'Sự kiện' | 'Cảnh báo' | 'Cho' | 'Nhờ' | 'Cần';

const postTypes: { type: PostType; bgColor: string; textColor: string }[] = [
  { type: 'Chia sẻ', bgColor: 'bg-[#DCF3FF]', textColor: 'text-[#0071B4]' },
  { type: 'Sự kiện', bgColor: 'bg-[#FFCFFF]', textColor: 'text-[#AD00AD]' },
  { type: 'Cảnh báo', bgColor: 'bg-[#FEE4E2]', textColor: 'text-[#F04438]' },
  { type: 'Cho', bgColor: 'bg-[#D5F2EF]', textColor: 'text-[#215E60]' },
  { type: 'Nhờ', bgColor: 'bg-[#F5ECCC]', textColor: 'text-[#C88A2A]' },
  { type: 'Cần', bgColor: 'bg-[#F4E7DA]', textColor: 'text-[#E06448]' },
];

interface CreatePostTypeSelectorProps {
  selectedTag: PostType | null;
  onSelectTag: (tag: PostType) => void;
}

export const CreatePostTypeSelector: React.FC<CreatePostTypeSelectorProps> = ({ selectedTag, onSelectTag }) => {
  const isAnySelected = selectedTag !== null;
  return (
    <div className="w-full px-4 py-2">
      <div className="bg-[#FBF6F1] rounded-md shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)]">
        <div className="px-4 py-2 flex flex-col gap-3">
          <div className="flex items-start gap-2">
            <Tag className="w-4 h-4 text-[#1E3A3A] mt-1" />
            <div className="flex flex-col gap-0.5">
              <span className="text-[#1E3A3A] text-sm font-normal font-sora leading-tight">
                Loại bài đăng
              </span>
              <span className="text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                Chọn một trong các tag sau
              </span>
            </div>
          </div>
        </div>
        <div className="p-2 flex flex-wrap gap-2">
          {postTypes.map(({ type, bgColor, textColor }) => {
            const isSelected = selectedTag === type;
            const isDimmed = isAnySelected && !isSelected;
            return (
              <button
                key={type}
                className={`px-3 py-2 rounded-full text-[10px] font-normal font-sora leading-none transition-colors duration-150
                  ${isSelected ? `${bgColor} ${textColor}` : isDimmed ? 'bg-[#E7E7E6] text-[#504F4E]' : `${bgColor} ${textColor}`}
                `}
                onClick={() => onSelectTag(type)}
                type="button"
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}; 